import { Route } from "@angular/router";
import { LPComponent } from "./lp.component";
import { EditStockRouting } from "./edit-stock/edit-stock-routing";

export const LPRouting: Route = {
    path: "lp",
    component: LPComponent,
    data: {
        breadcrumb: "Linge plat"
    },
    children: [
        EditStockRouting
    ]
}
